// extracted by mini-css-extract-plugin
export default {"backToReferrer":"_1807k6l"};